import {
    Grid,
    TextField,
    Typography,
    List,
    ListItem,
    ListItemText,
    ListItemLink,
    Checkbox,
    Button,
    makeStyles,
    FormControl,
    IconButton,
    Input,
    InputLabel,
    InputAdornment
} from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { Imports } from '../../../Imports';
import Box from '@mui/material/Box';
import { helpers } from '../../../helpers';
import services from '../../../Services';

import Snackbar from '../../../Components/Snackbar';
import Modal from '@mui/material/Modal';
import { useHistory, Link, useLocation, useParams } from "react-router-dom";
import { environment as env } from '../../../environments/environment';

const ApplicantPassword = () => {
    let history = useHistory();


    const style_reset = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        // width: '80%',
        // height: '80%',
        bgcolor: 'background.paper',
        // border: '2px solid #000',
        borderRadius: '20px',
        boxShadow: 24,
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '40px'
    };


    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        height: '80%',
        bgcolor: 'background.paper',
        // border: '2px solid #000',
        borderRadius: '20px',
        boxShadow: 24,
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '240px'
    };



    const {
        users
    } = services;
    const {
        showSnackBar,
    } = helpers;
    const [error, setError] = useState(false);
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [open, setOpen] = React.useState(false);
    const [resetopen, setResetOpen] = React.useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const ResethandleOpen = () => setResetOpen(true)
    const ResethandleClose = () => setResetOpen(false)
    const divStyles = { display: "flex", alignItems: "center", backgroundColor: "white", padding: "0px 10px", borderRadius: "10px" }

    const [values, setValues] = React.useState({
        amount: '',
        password: '',
        weight: '',
        weightRange: '',
        showPassword: false,
        showConfirmPassword: false,
    });
    // let uid = '1231231231231';
    // let uid = '30d2f15a-359f-4490-a720-366e67158b44';
    let { uid } = useParams();



    useEffect(async () => {
        let response = await fetch(`${env?.apiPath}employee/forgetPassword/${uid}`)
         
        if (response.status !== 200)
            setOpen(true)
        // window.scrollTo(0, 0);
    }, []);
    const handleClickShowPassword = () => {
        setValues({ ...values, showConfirmPassword: !values.showConfirmPassword });
    };
    const handleClickShowPasswordV = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };

    const validatePassword = async (password) => {
        try {
            return await Imports
                .validators
                .password
                .validate(password);
        } catch (exc) {
            showSnackBar(exc.message);
            throw exc;
        }
    }
    async function submit() {
        let data = {
            uid,
            password: password,
            confirm_password: confirmPassword
        }
        if (password === confirmPassword) {
            setError(false)
            try {
                const isValid = await validatePassword(password);

                const createPassword = await users.ApplicantChangePassword(data)
                if (createPassword?.httpStatus == 200)
                    // history.push("/");
                    setResetOpen(true)
            }
            catch (exc) {
                 
            }
        }
        else {
            setError(true);

            return false;
        }
    }
    return (
        <div>
            <Grid container xs={12}>
                <Grid className="LoginImageBG">
                    <Grid className="LoginImage">
                        <Grid className="LoginLogo"></Grid>
                        <Grid className="LoginText">
                            Applicant Portal
                        </Grid>
                    </Grid>
                </Grid>
                <Grid className="LoginFormPlace CreatePwdForm">
                    <Grid className="LoginForm">
                        <Grid className="LoginTitle">Reset Password</Grid>
                        <Grid className="FormFields">
                            <Typography xs={12} className="CreateFieldTItle">Reset Password</Typography>
                            <FormControl className="LoginPwd">
                                {/* <InputLabel htmlFor="standard-adornment-password">Password</InputLabel> */}
                                <div style={divStyles}>
                                    <Input
                                        placeholder="Password"
                                        id="standard-adornment-password"
                                        type={values.showPassword ? 'text' : 'password'}
                                        style={{ width: "100%" }}
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}

                                    />
                                    {values.showPassword ? <Visibility style={{ cursor: "pointer" }} onClick={handleClickShowPasswordV} /> : <VisibilityOff style={{ cursor: "pointer" }} onClick={handleClickShowPasswordV} />}
                                </div>
                            </FormControl>
                            <Typography xs={12} className="CreateFieldTItle">Confirm Reset Password</Typography>
                            <FormControl className="LoginPwd">
                                {/* <InputLabel htmlFor="standard-adornment-password">Password</InputLabel> */}
                                <div style={divStyles}>
                                    <Input
                                        placeholder="Verify Password"
                                        id="standard-adornment-password"
                                        type={values.showConfirmPassword ? 'text' : 'password'}
                                        value={confirmPassword}
                                        onChange={e => setConfirmPassword(e.target.value)}
                                        style={{ width: "100%" }}
                                    // endAdornment={
                                    //   <InputAdornment position="end">
                                    //     <IconButton
                                    //       aria-label="toggle password visibility"
                                    //       onClick={handleClickShowPasswordV}
                                    //       onMouseDown={handleMouseDownPasswordV}
                                    //     >
                                    //       {values.showPassword ? <Visibility /> : <VisibilityOff />}
                                    //     </IconButton>
                                    //   </InputAdornment>
                                    // }
                                    />
                                    {values.showConfirmPassword ? <Visibility style={{ cursor: "pointer" }} onClick={handleClickShowPassword} /> : <VisibilityOff style={{ cursor: "pointer" }} onClick={handleClickShowPassword} />}
                                </div>
                            </FormControl>
                            {error == true ?
                                <h5>Password does not match</h5>
                                : ""}

                            {/* <TextField placeholder="Password" type="password"/> */}
                            <Grid xs={12} container className="mt16 pwdcriteria">
                                <Typography variant="h5" component="h6">
                                    Password Criteria
                                </Typography>
                                <List component="nav" aria-label="secondary mailbox folders">
                                    <ListItem>
                                        <ListItemText primary="Must be eight or more characters long" />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText primary="Password must contain three of the following four categories" />
                                    </ListItem>
                                    <ListItem>
                                        <List component="nav" aria-label="secondary mailbox folders">
                                            <ListItem>
                                                <ListItemText primary="Upper Case Characters A-Z" />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText primary="Lower Case Characters a-z" />
                                            </ListItem>
                                            <ListItem />
                                            <ListItem>
                                                <ListItemText primary="Digits 0-9" />
                                            </ListItem>
                                            <ListItem>
                                                <ListItemText primary="Special Characters (!,$,#,%,etc)" />
                                            </ListItem>
                                        </List>
                                    </ListItem>
                                </List>
                            </Grid>
                            <Grid xs={12} container justify="center" className="mt40 mb40">
                                <Button onClick={submit} className="ApplicantBtn">Reset</Button>
                                <Snackbar
                                ></Snackbar>
                            </Grid>

                            <Grid xs={12}>
                                <Modal
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                >
                                    <Box sx={style}>

                                        <Typography id="modal-modal-description" sx={{ mt: 2 }} style={{ textAlign: 'center' }}>
                                            your reset password link is expired or invalid. Please request another link.
                                        </Typography>
                                        <Link to="/forgetPassword" className="ApplicantBtn1" style={{ marginTop: '30px' }}>OK</Link>
                                    </Box>
                                </Modal>

                            </Grid>
                            <Grid xs={12}>
                                <Modal
                                    open={resetopen}
                                    onClose={ResethandleClose}
                                    aria-labelledby="modal-modal-title"
                                    aria-describedby="modal-modal-description"
                                >
                                    <Box sx={style_reset}>

                                        <Typography id="modal-modal-description" sx={{ mt: 2 }} style={{ textAlign: 'center' }}>
                                            Your Password has been Reset successfully
                                        </Typography>
                                        <Link to="/" className="ApplicantBtn1" style={{ marginTop: '30px' }}>OK</Link>
                                    </Box>
                                </Modal>

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}

export default ApplicantPassword